import type {
  RsvpSubmitRequest,
  RsvpSubmitResponse,
  ApiError,
} from "@trou/shared";

const BASE = (import.meta.env.VITE_API_BASE ?? "/api").replace(/\/$/, "");

async function request<TBody, TRes>(path: string, body: TBody): Promise<TRes> {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = (await res.json().catch(() => ({}))) as TRes | ApiError;
  if (!res.ok) {
    const err = json as ApiError;
    throw new Error(err?.message ?? `API error ${res.status}`);
  }
  return json as TRes;
}

export const api = {
  submitRsvp: (body: RsvpSubmitRequest) =>
    request<RsvpSubmitRequest, RsvpSubmitResponse>("/rsvp/submit", body),
};
